import permissions from '../../permissions'

const MONITORING_MANAGEMENT_KPI_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.MONITORING_MANAGEMENT_KPI.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.MONITORING_MANAGEMENT_KPI.MANAGE,
  },
]

export default MONITORING_MANAGEMENT_KPI_LIST
